import React, {FunctionComponent, useState} from 'react';
import {Box, makeStyles, Theme, Typography} from '@material-ui/core';
import UserAvatar from "../UserAvatar";
import ReferralCoins from "../../ReferralsScreen/ReferralCoins";
import {FormattedHTMLMessage, useIntl} from "react-intl";
import cx from "classnames";
import RieltorBenefits from "../RieltorBenefits";
import * as UserSelectors from "../../../store/user/selectors";


const useStyles = makeStyles<Theme>(theme => ({
  formReffTitle: {
    fontWeight: 700,
    fontSize: 22,
    lineHeight: 1.5,
    marginBottom: 18,
    '& img': {
      display: 'inline-block',
      width: 28,
      height: 28,
      verticalAlign: 'text-bottom',
      borderRadius: '50%',
      objectFit: 'cover'
    },
    '& a': {
      color: '#8811FF',
      textDecoration: 'underline',
      textDecorationThickness: '2px',
      textUnderlineOffset: '4px',
    }
  },
  reffBenefitsWr: {
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  reffBenefitsWrVisible: {
    display: 'block'
  },
  reffBenefits: {
    display: 'flex',
    flexWrap: 'wrap',
    marginRight: -8,
    [theme.breakpoints.down('xs')]: {
      marginRight: 16,
    }
  },
  reffBenefitsShowBtn: {
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid #000',
      borderRadius: 4,
      fontSize: 13,
      fontWeight: 700,
      marginTop: 8,
      '& svg': {
        marginRight: 6,
        width: 10,
        height: 10,
        fill: 'currentColor'
      }
    },
  },
  reffBenefitTitle: {
    fontSize: 18,
    lineHeight: 1.44,
    fontWeight: 700,
    marginBottom: 22,
    '& a': {
      color: '#8811FF',
      textDecoration: 'underline',
      textDecorationThickness: '2px',
      textUnderlineOffset: '4px',
    }
  },
  reffBenefit: {
    width: '50%',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 1.5,
    display: 'flex',
    marginBottom: 20,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 10,
    },
    '&:nth-child(1) img': {
      width: 26,
    },
    '&:nth-child(2) img': {
      width: 22,
    },
    '&:nth-child(3) img': {
      width: 26.45,
    },
    '&:nth-child(4) img': {
      width: 28,
    },
    '&:nth-child(5) img': {
      width: 20.81,
    },
    '&:nth-child(6) img': {
      width: 22,
    },
  },
  reffBenefitImage: {
    width: 38,
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    paddingTop: 4,
    paddingRight: 8,
    [theme.breakpoints.down('xs')]: {
      width: 42,
      paddingRight: 10,
      paddingTop: 0,
      alignItems: 'center',
    }
  },

  infoWrap:{
    borderRight: '1px solid #D9D9D9',
    paddingRight: 37,
    marginBottom: 31,
    paddingBottom: 8,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
      border: 0,
      borderBottom: '1px solid #D9D9D9',
      paddingBottom: 34
    }
  },
  formReffWrap: {
    borderRight: '1px solid rgba(0, 0, 0, 0.11)',
    fontFamily: 'Inter',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingRight: 37,
    marginBottom: 31,
    paddingBottom: 8,
    [theme.breakpoints.down('xs')]: {
      paddingBottom: 21,
      // marginLeft: 32,
      // marginRight: 32,
      paddingLeft: 0,
      paddingRight: 0,
      borderRight: 0,
      borderBottom: '1px solid rgba(0, 0, 0, 0.11)',
    }
  },
}));

interface ReferralRegistrationInfoProps {
  referral: string;
  referralInfo: any;
  bonus?: number;
}

const ReferralRegistrationInfo: FunctionComponent<ReferralRegistrationInfoProps> = ({referralInfo, referral, bonus}: ReferralRegistrationInfoProps) => {
  const classes = useStyles();
  const {formatMessage: fm} = useIntl();

  return (
    <>
      {referral && referralInfo && (
        <Box className={classes.formReffWrap}>
          <Box className={classes.formReffTitle}>
            <UserAvatar
              imageKey={referralInfo.avatar}
              width={53}
              height={53}
              rounded
            />{' '}
            {referralInfo.username}{' '}
            {fm({id: 'referrals.register_title1'})}{' '}
            <a
              href={process.env.REACT_APP_LEGACY_INTERFACE_BASE_URL}
              target="_blank"
            >
              RIELTOR.UA
            </a>
          </Box>

          <Box mb={2} className={classes.formReffText2}>
            <FormattedHTMLMessage id="referrals.register_title2_1" />{' '}
            <ReferralCoins color="inherit" value={(bonus || 0) / 10} />{' '}
            {fm({id: 'referrals.register_title2_2'})}
          </Box>

          <RieltorBenefits/>
        </Box>
      )}
    </>
  );
};

export default ReferralRegistrationInfo;